import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Flex, Form, Row, Typography } from "antd";

import { GET } from "../../../providers/useAxiosQuery";
import PageEvaluationCategoryFormQuestion from "./components/PageEvaluationCategoryFormQuestion";

export default function PageEvaluationCategoryForm() {
	const params = useParams();
	const navigate = useNavigate();

	const [dataSource, setDataSource] = useState();

	const [form] = Form.useForm();

	if (params.category_id) {
		GET(
			`api/form_question_category/${params.category_id}`,
			"form_question_category_info",
			(res) => {
				console.log("form_question_category", res);
				if (res.data) {
					let form_questions = res.data.form_questions.map((item) => {
						return {
							...item,
							checkbox_with_input:
								item.checkbox_with_input === 1 ? true : false,
							with_attachment: item.with_attachment === 1 ? true : false,
							required: item.required === 1 ? true : false,
						};
					});
					let data = {
						...res.data,
						form_questions,
					};
					form.setFieldsValue(data);
					setDataSource(data);
				}
			}
		);
	}

	useEffect(() => {
		const linkSurveyViewFn = () => {
			navigate(`/survey/view/${params.form_id}`);
		};
		let linkSurveyView = document.querySelector(".link_survey_view");
		if (linkSurveyView) {
			linkSurveyView.addEventListener("click", linkSurveyViewFn);
		}

		return () => {
			if (linkSurveyView) {
				linkSurveyView.removeEventListener("click", linkSurveyViewFn);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Row gutter={[12, 20]}>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Button
					type="primary"
					className="btn-main-primary"
					icon={<FontAwesomeIcon icon={faArrowLeft} />}
					onClick={() => navigate(-1)}
				>
					BACK
				</Button>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex gap={10} align="start">
					<Typography.Text strong className="mt-0">
						CATEGORY:
					</Typography.Text>
					<span
						className="quill-output"
						dangerouslySetInnerHTML={{
							__html: dataSource?.category,
						}}
					/>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<PageEvaluationCategoryFormQuestion
					form_question_category_id={params.category_id}
				/>
			</Col>
		</Row>
	);
}
